<template>
  <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
    <div class="page_header">
      <span class="page_title">{{ $t('oilChart.车辆油耗与车速变化趋势图') }}</span>
      <el-form :inline="true" :size="size" style="flex:1;text-align: right;">
        <el-form-item :label="$t('time.timeQuery')">
          <el-date-picker v-model="queryDate" type="date" value-format="yyyy-MM-dd" :placeholder="$t('龙翼简报.选择日期')">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="onQuery">{{ $t('public.query') }}</el-button>
        </el-form-item>

      </el-form>
    </div>
    <el-divider></el-divider>
    <div v-loading="loading" style="height: calc(100% - 100px);">
      <div ref="chartRef" class="chart-content"></div>
    </div>
  </div>
</template>

<script>
// import * as echarts from "echarts";

import { querySpeedOilCurve } from '@/http/oil'
import { mapState } from 'vuex'
export default {
  name: 'OilChart',
  data() {
    return {
      chart: null,
      queryDate: this.getTodayDate(),
      vehicleId: '',
      vehicles: [],
      loading: false,
      chartData: {
        timeLabels: [],
        fuelData: [],
        speedData: []
      }
    }
  },
  mounted() {
    this.initChart()

  },
  computed: {
    size() {
      return this.$store.getters.size
    },
    ...mapState({
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    getTodayDate() {
      //往前退一天
      var date = new Date();
      date.setDate(date.getDate());
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
   
    initChart() {
      this.chart = echarts.init(this.$refs.chartRef)
      const option = {

        tooltip: {
          trigger: 'axis',
          formatter:  (params) =>{
            let result = params[0].name + '<br/>'
            params.forEach(param => {
              const unit = param.seriesName === this.$t('oilChart.剩余油量') ? 'L' : 'km/h'
              result += `${param.marker}${param.seriesName}: ${param.value}${unit}<br/>`
            })
            return result
          }
        },
        legend: {
          data: [this.$t('oilChart.剩余油量'), this.$t('oilChart.车速')],
          bottom: 10
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: [
          {
            type: 'value',
            name: this.$t('oilChart.剩余油量')+'(L)',
            position: 'left',
            axisLabel: {
              formatter: '{value} L'
            }
          },
          {
            type: 'value',
            name: this.$t('oilChart.车速')+'(km/h)',
            position: 'right',
            axisLabel: {
              formatter: '{value} km/h'
            }
          }
        ],
        series: [
          {
            name: this.$t('oilChart.剩余油量'),
            type: 'line',
            data: [],
            smooth: true,
            lineStyle: {
              width: 2
            },
            itemStyle: {
              color: '#1890ff'
            }
          },
          {
            name: this.$t('oilChart.车速'),
            type: 'line',
            yAxisIndex: 1,
            data: [],
            smooth: true,
            lineStyle: {
              width: 2
            },
            itemStyle: {
              color: '#52c41a'
            }
          }
        ]
      }
      this.chart.setOption(option)
      window.addEventListener('resize', this.handleResize)
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    },

    onQuery() {

      if (this.selectedVehicles.length == 0) {
        this.$message.warning(this.$t("vehicletrack.selectvehicle"));
        return;
      }
      if (this.selectedVehicles.length > 1) {
        this.$message.warning(this.$t("vehicletrack.selectmorevehicle"));
        return;
      }
      // console.log(this.selectedVehicles[0]);
      if (!this.queryDate.length) {
        this.$message.error(this.$t("time.selectQueryTime"));
        return;
      }
      var VehicleID = this.selectedVehicles[0].nodeValue
      this.loading = true;

      querySpeedOilCurve({
        "BeginTime": this.queryDate + " 00:00:00",
        "VehicleID": VehicleID,
        "EndTime": this.queryDate + " 23:59:59"
      }).then(res => {
        this.loading = false

        // if(res.code == 0){
    //没有数据
    if(res.data.length == 0){
      this.$message.warning(this.$t("public.noData"));
      return;
    }

        this.updateChartData({

          timeLabels: res.data.map(item => item.GpsDateTime.split(' ')[1]),
          fuelData: res.data.map(item => item.OilCubage),
          speedData: res.data.map(item => item.MeterSpeed)
        })
        // }
      })

    },
    updateChartData(data) {
      this.chartData = data || {
        timeLabels: [],
        fuelData: [],
        speedData: []
      }
      this.chart.setOption({
        xAxis: {
          data: this.chartData.timeLabels
        },
        series: [
          {
            data: this.chartData.fuelData
          },
          {
            data: this.chartData.speedData
          }
        ]
      })
    },

  }
}
</script>

<style scoped>
 

.chart-content {
  width: 100%;
  height: calc(100% - 80px);
  min-height: 400px;
}
 
</style>